import { jsx as _jsx } from "react/jsx-runtime";
import { BottomNavBarProvider } from '@agentguru/layout';
import { useBottomNavBarRoutes } from '@/routes/hooks';
export function AppBottomNavBarProvider(_a) {
    var children = _a.children;
    var bottomNavBarRoutes = useBottomNavBarRoutes();
    return (_jsx(BottomNavBarProvider, { routes: bottomNavBarRoutes, children: children }));
}
